import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { TrashIcon } from "@heroicons/react/24/outline";

function PhoneNumberTable(props) {
  const { communicationBinding, onItemDelete, locked } = props;

  if (communicationBinding.length === 0) {
    return (
      <div className="flex items-center justify-center h-full min-h-0 border rounded-lg">
        <p className="text-base font-medium">No numbers</p>
      </div>
    );
  }

  return (
    <div className="border rounded-lg p-4 h-full min-h-0 flex-1 overflow-auto">
      <Table>
        <TableHead>
          <TableHeader>Number</TableHeader>
          {!locked && <TableHeader>Action</TableHeader>}
        </TableHead>
        <TableBody>
          {communicationBinding.map((binding, idx) => {
            const handleItemDelete = () => {
              onItemDelete(binding);
            };

            return (
              <TableRow key={idx}>
                <TableCell>
                  <p>{binding.identifier}</p>
                </TableCell>
                {!locked && (
                  <TableCell>
                    <Button
                      outline
                      onClick={handleItemDelete}
                    >
                      <TrashIcon />
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

export { PhoneNumberTable };
